import React from 'react';
import { useTranslation } from 'react-i18next';
import './Loading.css';

function Loading({ 
  message, 
  className = '', 
  fullScreen = false,
  size = 'medium', // 'small' | 'medium' | 'large'
  hideText = false
}) {
  const { t } = useTranslation('shared');
  const displayMessage = message || t('common.loading');

  const containerClass = [
    'loading-container',
    fullScreen && 'loading-fullscreen',
    size && `loading-${size}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <div 
      className={containerClass}
      role="status"
      aria-live="polite"
      aria-label={displayMessage}
    >
      <div className="loading-spinner" aria-hidden="true">
        <span className="loading-spinner-ring"></span>
        <span className="loading-spinner-dot loading-spinner-dot-1"></span>
        <span className="loading-spinner-dot loading-spinner-dot-2"></span>
        <span className="loading-spinner-dot loading-spinner-dot-3"></span>
      </div>
      {!hideText && (
        <p className="loading-message">{displayMessage}</p>
      )}
    </div>
  );
}

export default Loading;
